/* Combined family picker (cubes-style groups) — shared functions.
   Extracted from product-form-component-product-group.liquid 2026-08-25:
   the drawer injects the picker via x-html, which never executes inline
   <script> blocks, so pills threw "gpMemberFilter is not defined" in the
   quick-buy drawer. Loaded sitewide from theme.liquid (defer).

   Roots: on a PDP the picker lives in a .shopify-section; in the
   quick-buy drawer it lives in the modal's [data-might-be-empty] host,
   which is created fresh on every open (so filter state and observers
   never leak between products). In-drawer member swaps morph the drawer
   content in place via the same selectGroupProduct anchor as the PDP. */

(function () {
  function gpRoot(el) {
    return el.closest('.shopify-section') || el.closest('[data-might-be-empty]');
  }

  /* FILTER STATE (consolidated 2026-10-20 - Hagan: "the site will build on
     these foundational changes"). ONE value per picker scope is the truth:
       - product page: window.gpPdpFilter (survives no-reload swaps)
       - quick-buy drawer: data-gp-filter on its [data-might-be-empty] host
         (the host survives in-drawer swaps; a new host per open)
     A pill tap SETS it; gpSync() PAINTS it onto whatever picker is on screen;
     swaps paint the incoming product before it's inserted
     (window.gpBeforeSwapInsert, called by utils.js); one observer repaints
     after any theme re-render. No parked/pending values, no delays, no
     timestamps - nothing to race. Unset state is read once from the page
     (?gp_pill= after a fallback navigation, else the pill Liquid marked
     active), so first loads look exactly as before. */
  function gpScopeHost(el) {
    return el && el.closest ? el.closest('[data-might-be-empty]') : null;
  }
  function gpGetFilter(el) {
    var host = gpScopeHost(el);
    var f = host ? host.getAttribute('data-gp-filter') : window.gpPdpFilter;
    if (f) return f;
    // first read for this scope: take it from the page
    var root = gpRoot(el) || document;
    var m = !host && /[?&]gp_pill=([^&]+)/.exec(window.location.search);
    var marked = root.querySelector && root.querySelector('[data-gp-pillfilter][aria-current]');
    f = (m && decodeURIComponent(m[1])) || (marked && marked.getAttribute('data-gp-pillfilter')) || 'all';
    gpSetFilter(el, f);
    return f;
  }
  function gpSetFilter(el, handle) {
    var host = gpScopeHost(el);
    if (host) host.setAttribute('data-gp-filter', handle);
    else window.gpPdpFilter = handle;
  }
  // every FILTERABLE picker root inside a container (a PDP section, or the
  // drawer host; a detached swap fragment falls back to the fragment itself).
  // Only pickers with brand pills: a Singles/Multipacks family (Mega Fillers)
  // has member chips but no pills, and stamping it with data-gp-filter let the
  // pill CSS strip its active tab's fill (Hagan 2026-10-20)
  function gpPickerRoots(container) {
    var roots = [];
    container.querySelectorAll('[data-gp-pillfilter]').forEach(function (el) {
      var r = gpRoot(el) || container;
      if (roots.indexOf(r) === -1) roots.push(r);
    });
    return roots;
  }
  // paint the scope's filter onto the pickers inside container
  window.gpSync = function (container, scopeEl) {
    gpPickerRoots(container || document).forEach(function (root) {
      var f = gpGetFilter(scopeEl || root);
      if (root.getAttribute('data-gp-filter') !== f) root.setAttribute('data-gp-filter', f);
      window.gpApplyFilter(root);
    });
  };

  window.gpMemberFilter = function (btn, handle, url, optionCount, currentHandle) {
    var root = gpRoot(btn) || document;
    var chips = root.querySelectorAll('[data-gp-member]');
    gpSetFilter(btn, handle);
    // rev 2026-08-25 (Hagan): a pill for ANOTHER family member's bucket
    // swaps to that bucket's lead product; the filter (already set above)
    // is painted onto the incoming product before it shows
    if (handle !== 'all' && handle !== currentHandle) {
      // gp_pill only rides along for a real navigation (fallback)
      var navUrl = url + (optionCount > 1 ? (url.indexOf('?') === -1 ? '?' : '&') + 'gp_pill=' + encodeURIComponent(handle) : '');
      window.gpSync(root);
      if (!window.gpSwapWithFilter(root, navUrl, handle)) window.location = navUrl;
      return;
    }
    if (!chips.length) {
      if (!window.gpSwapWithFilter(root, url, 'all')) window.location = url;
      return;
    }
    window.gpSync(root);
  };

  // 2026-10-20 (Hagan: "All -> Daniel Tiger -> Sesame Street, the first time
  // it's a bit slow"): the product island preloads every family page into the
  // fetch cache keyed by its PLAIN url - swaps must not add ?gp_pill= (a
  // cache miss re-downloads the page, ~0.7s)
  function gpPlainUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete('gp_pill');
      return u.toString();
    } catch (e) { return url; }
  }
  window.gpPlainUrl = gpPlainUrl;

  window.gpSwapWithFilter = function (root, url, filterHandle) {
    var a = root.querySelector && root.querySelector('[data-gp-swap]');
    if (!a) return false;
    var navUrl = url;
    // a pill tapped on a section that was JUST swapped in (island not
    // hydrated yet) would click an anchor with no Alpine handler - a full
    // reload. Hold it and swap once ready; a newer swap drops it; a >1.5s
    // boot navigates.
    var island = a.closest('data-island');
    if (island && !island.hasAttribute('ready')) {
      var t0 = Date.now();
      (function waitForIsland() {
        if (!island.isConnected) return;
        if (island.hasAttribute('ready')) { window.gpSwapWithFilter(root, navUrl, filterHandle); return; }
        if (Date.now() - t0 > 1500) { window.location = navUrl; return; }
        setTimeout(waitForIsland, 50);
      })();
      return true;
    }
    a.setAttribute('href', gpPlainUrl(url));
    a.click();
    return true;
  };

  window.gpChipSwap = function (el) {
    var root = gpRoot(el);
    if (!root) return false; // unknown context: let the link navigate
    return window.gpSwapWithFilter(root, el.getAttribute('href'), gpGetFilter(el));
  };

  // called by utils.js just before a swapped-in product is put on screen:
  // paint the scope's filter so it lands already filtered (no "All" frame)
  window.gpBeforeSwapInsert = function (newEl, oldEl) {
    window.gpSync(newEl, oldEl || document.body);
  };

  // repaint after any theme re-render (selecting a variant re-renders the
  // picker and wipes pill states / inline styles; swaps insert new pickers).
  // childList only - our own attribute/style writes don't re-trigger it.
  var gpSyncQueued = false;
  new MutationObserver(function () {
    if (gpSyncQueued) return;
    gpSyncQueued = true;
    requestAnimationFrame(function () {
      gpSyncQueued = false;
      if (document.querySelector('[data-gp-pillfilter], [data-gp-member]')) window.gpSync(document);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.gpApplyFilter = function (root) {
    var handle = root.getAttribute('data-gp-filter');
    if (!handle) return;
    root.querySelectorAll('[data-gp-pillfilter]').forEach(function (b) {
      if (b.getAttribute('data-gp-pillfilter') === handle) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
    });
    // bucket filters (bkt-*, catalog Batch B pill rule): painting is done
    // by Liquid-emitted attribute-selector CSS keyed on [data-gp-filter] -
    // clear inline styles so the CSS can take over (a bucket handle never
    // equals a member handle, so the per-member match below would hide all)
    if (handle.indexOf('bkt-') === 0) {
      root.querySelectorAll('[data-gp-member]').forEach(function (el) {
        el.style.display = '';
      });
      return;
    }
    root.querySelectorAll('[data-gp-member]').forEach(function (el) {
      el.style.display = handle === 'all' || el.getAttribute('data-gp-member') === handle ? '' : 'none';
    });
  };

  // 2026-10-19: a family chip tapped BEFORE its picker island hydrates is a
  // plain link, so the browser navigated and pushed a history entry per
  // Pal - Back then stepped through every Pal instead of returning to the
  // collection. Hydrated taps swap with replaceState; a held tap replays as
  // a swap. The filter needs no handling here: it's scope state, painted
  // onto whatever lands. Only visible chips are tappable, so the tapped
  // member is always inside the active brand.
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('[data-gp-member] a[href], a[data-gp-member][href]');
    if (!a || a.target === '_blank') return;
    if (!a.closest('.shopify-section')) return; // drawer: Alpine swaps it
    var row = a.closest('[data-gp-member]') && a.closest('[data-gp-member]').parentElement;
    var ring = function () {
      if (!row) return;
      row.querySelectorAll('[data-gp-member] a.is-selected').forEach(function (x) { x.classList.remove('is-selected'); });
      a.classList.add('is-selected');
    };
    var island = a.closest('data-island');
    if (!island || island.hasAttribute('ready')) {
      // hydrated: Alpine swaps in place; ring the tapped swatch right away
      ring();
      return;
    }
    // 2026-10-20 (Hagan: "reduce any flickering"): a quick second tap lands
    // on the section the first tap JUST swapped in, before its island
    // hydrates - that used to be a full page reload. Hold it (ring now),
    // replay as a swap once the island is ready; a newer swap drops it; only
    // a genuinely slow boot (>1.5s) navigates.
    e.preventDefault();
    ring();
    var filter = gpGetFilter(a);
    var url = a.href + (filter.indexOf('bkt-') === 0 ? (a.href.indexOf('?') === -1 ? '?' : '&') + 'gp_pill=' + encodeURIComponent(filter) : '');
    var t0 = Date.now();
    (function waitForIsland() {
      if (!island.isConnected || !a.isConnected) return;
      if (island.hasAttribute('ready')) { a.click(); return; }
      if (Date.now() - t0 > 1500) { window.location.replace(url); return; }
      setTimeout(waitForIsland, 50);
    })();
  }, true);

  // 2026-10-20: photo head starts. The product island preloads every family
  // page's HTML; from that cached HTML take photo 1 (cheap string search, NOT
  // a DOM parse - that doubled the main-thread work on slow phones) and start
  // it downloading, so the swap rarely waits for it:
  //  - pill targets (3-4 pages) once the page is idle ("the first time it's
  //    a bit slow" - Hagan, All -> Daniel Tiger -> Sesame Street)
  //  - any swatch/pill on touch-down (~50-120ms before the click fires)
  var gpPreloaded = {};
  function gpPreloadLeadFromCache(url, priority) {
    if (!url) return;
    var key = new URL(gpPlainUrl(url), window.location.origin).toString();
    if (gpPreloaded[key] === 'high' || (gpPreloaded[key] && priority !== 'high')) return;
    var cached = window.__fetchCache && window.__fetchCache[key];
    if (!cached || typeof cached.then !== 'function') return;
    gpPreloaded[key] = priority;
    cached.then(function (html) {
      if (typeof html !== 'string') return;
      var at = html.indexOf('class="product-media', html.indexOf('<main id="MainContent"'));
      var tagStart = at === -1 ? -1 : html.indexOf('<img', at);
      if (tagStart === -1) return;
      var tag = html.slice(tagStart, html.indexOf('>', tagStart) + 1);
      var attr = function (name) {
        var m = new RegExp('\\s' + name + '="([^"]*)"').exec(tag);
        return m ? m[1].replace(/&amp;/g, '&') : '';
      };
      var pre = new Image();
      pre.fetchPriority = priority;
      if (attr('sizes')) pre.sizes = attr('sizes');
      if (attr('srcset')) pre.srcset = attr('srcset');
      pre.src = attr('src');
    }).catch(function () {});
  }
  function gpPillTarget(pill) {
    if (pill.getAttribute('data-gp-pillfilter') === 'all') return null;
    var m = /gpMemberFilter\(this,\s*'[^']*',\s*'([^']+)'/.exec(pill.getAttribute('onclick') || '');
    return m && m[1];
  }

  document.addEventListener('pointerdown', function (e) {
    var el = e.target.closest && e.target.closest('[data-gp-member] a[href], a[data-gp-member][href], [data-gp-pillfilter]');
    if (!el) return;
    gpPreloadLeadFromCache(el.hasAttribute('data-gp-pillfilter') ? gpPillTarget(el) : el.href, 'high');
  }, { passive: true, capture: true });

  // pill targets on idle - re-armed after every swap (new pills, new targets);
  // the island's own HTML preload must land first, so retry a few times
  function gpIdlePillPreload(tries) {
    if (window.shouldTryToSaveData && window.shouldTryToSaveData()) return;
    var pending = 0;
    document.querySelectorAll('[data-gp-pillfilter]').forEach(function (pill) {
      var url = gpPillTarget(pill);
      if (!url) return;
      var key = new URL(gpPlainUrl(url), window.location.origin).toString();
      if (window.__fetchCache && window.__fetchCache[key]) gpPreloadLeadFromCache(url, 'low');
      else pending++;
    });
    if (pending && tries > 0) setTimeout(function () { gpIdlePillPreload(tries - 1); }, 1500);
  }
  var gpIdle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
  window.addEventListener('load', function () { gpIdle(function () { gpIdlePillPreload(6); }); });

  // first paint: state is derived from the page (?gp_pill= or the pill
  // Liquid marked active - DT's page filters to DT on a direct load)
  document.addEventListener('DOMContentLoaded', function () {
    window.gpSync(document);
  });
})();
